export const LOGGER_QUERY_PARAMS = {
	DEBUG_SMART_TAG: 'debugSmartTag',
	DEBUG: 'debug'
};

export enum LOGGER_ADAPTERS {
	CONSOLE = 'CONSOLE',
	// The following log adapters are Not Yet Implemented.
	// OVERLAY = 'OVERLAY',
}

/**
 * The Log Level is a number representing specificity that determines which
 * log messages will be recorded and shown.  Each Log Method is mapped to
 * a maximum Log Level.  If the current Log Level is HIGHER then the method's
 * Log Level then that method will not log anything.  Log Level starts at 1
 * (debug=1) and increases up to 9 (debug=9).
 * @type {Record<string,number>}
 */
export const LogLevels: Record<string, number> = {
	ERRORS_AND_INFO: 9,
	IMPORTANT: 5,
	VERBOSE: 1
};

/**
 * List of all supported Log Methods.  Could include methods not directly
 * supported by console if a log adapter implements it.
 * @type {Record<string,string>}
 */
export enum LogMethods {
	LOG = 'log',
	INFO = 'info',
	WARN = 'warn',
	ERROR = 'error',
	TABLE = 'table',
	GROUP = 'group',
	GROUP_COLLAPSED = 'groupCollapsed',
	GROUP_END = 'groupEnd'
}

/**
 * A mapping of Log Methods to their maximum Log Levels.  If the current Log
 * Level is higher than a method's mapped Log Level then calls to that method
 * will not record or display any logs.
 * @type {Record<string,number>}
 */
export const LogMethodsLevelsMap: Record<string, number> = {
	[ LogMethods.LOG ]: LogLevels.VERBOSE,
	[ LogMethods.TABLE ]: LogLevels.VERBOSE,
	[ LogMethods.GROUP ]: LogLevels.VERBOSE,
	[ LogMethods.GROUP_COLLAPSED ]: LogLevels.VERBOSE,
	[ LogMethods.GROUP_END ]: LogLevels.VERBOSE,

	[ LogMethods.WARN ]: LogLevels.IMPORTANT,

	[ LogMethods.ERROR ]: LogLevels.ERRORS_AND_INFO,
	[ LogMethods.INFO ]: LogLevels.ERRORS_AND_INFO
};